import script from "./SupportWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportWidget.vue?vue&type=script&setup=true&lang=js"

import "./SupportWidget.vue?vue&type=style&index=0&id=553adff0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-553adff0"]])

export default __exports__